export type ColumnLayout =
    '8 Center' |
    '8 Left Start 2' |
    '10 Center' |
    '12 Center';

export class ColumnLayouts {
    public static readonly CENTER_8: ColumnLayout = '8 Center';
    public static readonly LEFT_8_START_2: ColumnLayout = '8 Left Start 2';
    public static readonly CENTER_10: ColumnLayout = '10 Center';
    public static readonly CENTER_12: ColumnLayout = '12 Center';
}